import { observer } from "mobx-react-lite"
import React, { useContext, useState } from 'react'
import { toastError, toastSuccess } from "../../FormComponents/Toasts"
import { ClientSchema } from "../../../schemas/ClientSchema"
import Modal from "../../Modal/Modal"
import NewClientFirstPage from './NewClientModalParts/NewClientFirstPage'
import NewClientSecondPage from "./NewClientModalParts/NewClientSecondPage"
import { Formik, Form } from 'formik'
import axiosService from "../../../utils/AxiosService"
import { BrowseContext } from "../../../contexts/BrowseContext"

export default observer(function NewClientModal() {
  const { browseState, clients, openCreateClient } = useContext(BrowseContext)
  const [currentPage, setCurrentPage] = useState('firstPage')
  const [clientContacts, setClientContacts] = useState([])

  const handleSubmit = (client) => {
    const formData = new FormData()

    formData.append('client[name]', client.name)
    formData.append('client[theme_color]', client.theme_color)
    if (client.image)  formData.append('client[image]', client.image)
    client?.collaborators.forEach(collab => formData.append('client[collaborator_ids][]', collab.value))

    if (clientContacts.length !== 0) {
      clientContacts.forEach((contact, index) => {
        formData.append(`client[client_contacts_attributes][${index}][name]`, contact.name)
        formData.append(`client[client_contacts_attributes][${index}][email]`, contact.email)
        formData.append(`client[client_contacts_attributes][${index}][phone]`, contact.phone)
        formData.append(`client[client_contacts_attributes][${index}][notes]`, contact.notes)
        if (contact.image) formData.append(`client[client_contacts_attributes][${index}][avatar]`, contact.image)
      })
    }

    axiosService.post('/api/project_manager/clients', formData, { headers: { "Content-type": "multipart/form-data" } })
      .then((newClient) => {
        browseState.clients.push(newClient)
        browseState.toggleCreateClient()
        toastSuccess(`Client ${newClient.name} has been created!`)
      }).catch(({ data: { error } }) => toastError(error))
  }

  const newClientForm = {
    firstPage: NewClientFirstPage,
    secondPage: NewClientSecondPage,
  }

  const PageToRender = newClientForm[currentPage]

  const specificProps =  currentPage === 'secondPage' ? {
    clientContacts: clientContacts,
    setClientContacts: setClientContacts,
    setCurrentPage: setCurrentPage,
  } : {}

  return (
    < Modal isOpen={openCreateClient} onClose={() => browseState.openCreateClient = false }>
      <Modal.Header>Create Client</Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            name: '',
            collaborators: [],
            client_contacts: [],
            theme_color: '',
            image: '',
          }}
          validationSchema={ClientSchema}
          onSubmit={handleSubmit}
        >
          {({ setFieldValue, handleBlur, handleChange, values, touched, errors }) => (
            <Form className="w-[475px] -mt-10 dark:bg-rb-dark-mode">
              <PageToRender
                setFieldValue={setFieldValue}
                handleBlur={handleBlur}
                handleChange={handleChange}
                values={values}
                touched={touched}
                errors={errors}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                {...specificProps}
              />
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
})
